export enum DashboardsSubMenuUrl {
	dashboard = '/dashboards/dashboard',
	statusboard = '/dashboards/statusboard',
	createboard = '/dashboards/create',
}
